import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Header from '../../elements/Header';
import Text from '../../elements/Text';

function CheckList(props) {
  const {
    options,
    titleKey,
    itemListSettings,
    titleSettings,
    descriptionSettings,
    showHeader,
    headerSettings,
    onChange,
    value
  } = props;
  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  function handleElement(item) {
    const newElements = [...value];
    const index = newElements.indexOf(item.value);
    if (index !== -1) {
      newElements.splice(index, 1);
    } else {
      newElements.push(item.value);
    }
    onChange(newElements);
  }

  return (
    <Box className={`${CheckList.componentName} ${className} `} style={style}>
      {showHeader && (
        <Header
          textAlign="left"
          {...headerSettings}
          tag="h6"
          content={translate(titleKey, 'Home Type')}
        />
      )}
      <ul>
        {options.map((item) => {
          return (
            <Box
              key={item.value}
              onClick={() => handleElement(item)}
              display="flex"
              className="checkbox-container"
              dataTestId="checListOption"
              {...itemListSettings}
            >
              <Box marginRight="1">
                <input
                  className="custom-checkbox"
                  type="checkbox"
                  checked={value.indexOf(item.value) !== -1}
                  value={item.value}
                />
                <Text className="checkbox-label" />
              </Box>
              <Box display="flex" flexDirection="column">
                <Text textAlign="left" {...titleSettings}>
                  {translate(item.name, item.value)}
                </Text>
                <Text
                  type="p"
                  textAlign="left"
                  {...descriptionSettings}
                  className="checkbox-description"
                >
                  {translate(item.description, item.description)}
                </Text>
              </Box>
            </Box>
          );
        })}
      </ul>
    </Box>
  );
}

CheckList.propTypes = {
  /**
   * Class name of header
   */
  className: PropTypes.string,
  /**
   * Css style applied to the component
   */
  style: PropTypes.objectOf(PropTypes.any),
  /**
   * Options of sorting
   */
  options: PropTypes.arrayOf(PropTypes.string),
  titleKey: PropTypes.string,
  onChange: PropTypes.func,
  titleSettings: PropTypes.objectOf(PropTypes.any),
  headerSettings: PropTypes.objectOf(PropTypes.any),
  descriptionSettings: PropTypes.objectOf(PropTypes.any),
  itemListSettings: PropTypes.objectOf(PropTypes.any),
  /**
   * Value of the budget
   */
  value: PropTypes.arrayOf(PropTypes.string),
  showHeader: PropTypes.bool
};
CheckList.defaultProps = {
  options: [
    {
      name: 'cmp-airbnb-home-type-entire-place-label',
      description: 'cmp-airbnb-home-type-entire-place-description',
      value: 'Entire home/apt'
    },
    {
      name: 'cmp-airbnb-home-type-private-room-label',
      description: 'cmp-airbnb-home-type-private-room-description',
      value: 'Private room'
    },
    {
      name: 'cmp-airbnb-home-type-shared-room-label',
      description: 'cmp-airbnb-home-type-shared-room-description',
      value: 'Shared room'
    },
    {
      name: 'cmp-airbnb-home-type-hotel-room-label',
      description: 'cmp-airbnb-home-type-hotel-room-description',
      value: 'Hotel room'
    }
  ],
  className: '',
  style: {},
  titleKey: 'cmp-airbnb-home-type-label',
  onChange: () => {},
  itemListSettings: {
    display: 'flex',
    marginBottom: '2'
  },
  titleSettings: {
    fontSize: '14px'
  },
  headerSettings: {
    fontWeight: 'bold',
    fontSize: '14px'
  },
  descriptionSettings: {
    textColor: 'dark',
    fontSize: '12px'
  },
  value: [],
  showHeader: true
};

CheckList.contextType = Context;

CheckList.componentName = 'CheckList';

export default CheckList;
